import { BackButton } from "../components/backButton";
import { HeadLogo } from "../components/headLogo";
import images from "../images/images";


function AboutUsView({aboutUsData}) {


  const imageKey = `loc1_drawing`;

  function backToHomeACB() {
    window.location.hash = "#/";
  }

  return (
    <div className="aboutus-container">
      <HeadLogo/>
      <BackButton title="About us"/>
      <div className="aboutus-content">
  {aboutUsData.map((person, index) => (
    <div key={index} className="aboutus-info">
       <div className="aboutus-authors">
      <img className="aboutus-picture" src={images[person.img]}  />

      
     
      <a
          href={person.portfolio}
          target="_blank"
          className="aboutme-button"
        >
          portfolio
        </a>
      </div>
      <div className="aboutus-bioInfo">
      <div className="aboutus-ournames">{person.name}</div>
      <div className="aboutus-sentences">{person.bio}</div></div>
    </div>
  ))}
</div>

      <div>
      </div>
            {/* Dynamic Image at the bottom */}
            {images["drawing_loc01"] ? (
        <img
          src={images["drawing_loc01"]}
          className="aboutUs-bottom-illustration"
        />
      ) : (
        <div>Image not available</div>
      )}

    </div>
  );
}

export { AboutUsView };
